// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: runs from index.tsx before React mounts, so keep imports to the bridge
// and the Notification stand-in (no app stores).

import {getNativeMobilePlatform, isNativeMobileShell} from '@app/features/platform/native_mobile/NativeMobileBridge';
import {installNativeNotificationShim} from '@app/features/platform/native_mobile/NativeMobileNotificationShim';

export function installNativeMobileShellEarly(): void {
	if (!isNativeMobileShell()) return;
	document.documentElement.classList.add(
		'native-mobile-shell',
		`native-mobile-${getNativeMobilePlatform() ?? 'unknown'}`,
	);
	installNativeNotificationShim();
}
